import { gql } from "@apollo/client"

export const TIME_SLOT_FRAG = gql`
  fragment TimeSlotFrag on TimeSlotType {
    id
    name
    fromTime
    maximumOrders
    toTime
    thresholdFrom
    estimatedDelivery
  }
`

export const DISTRIBUTION_CENTER_LIST_FRAG = gql`
  fragment DistributionCenterListFrag on DistributionCentreType {
    id
    name
    archive
    photos {
      id
      url
    }
    address {
      id
      village
      state
    }
    pointOfContacts {
      id
      fullName
      number
    }
    allowedDepartments {
      id
      name
    }
    deliveryConditions
    deliverySlots {
      ...TimeSlotFrag
    }
    pickupSlots {
      ...TimeSlotFrag
    }
    maintenanceSlots {
      ...TimeSlotFrag
    }
    alternateSalesSlots {
      ...TimeSlotFrag
    }
  }
  ${TIME_SLOT_FRAG}
`

export const DISTRIBUTION_CENTER_DETAIL_FRAG = gql`
  fragment DistributionCenterDetailFrag on DistributionCentreProperties {
    currentStockPercentage
    name
    archive
    codename
    customerCode
    plantCode
    storeCode
    colorCode
    salesOfcCode
    partnerCode
    companyCode
    bankDetails {
      id
      ifscCode
      attachments {
        id
        url
        mediaType
      }
      bank {
        id
        name
        codename
      }
      accountHolderName
      accountNumber
      branchName
    }
    allowedDepartments {
      id
      name
    }
    assignedCpc {
      id
      name
    }
    certifications {
      id
      idNumber
      certificationType {
        id
        name
        codename
      }
      validFrom
      validTill
      attachments {
        id
        url
        mediaType
      }
    }
    groupVisibility {
      id
      name
      category {
        id
        name
        codename
      }
    }
    photos {
      id
      url
    }
    primaryPoc {
      id
      fullName
      number
    }
    address {
      id
      village
      taluka
      latitude
      longitude
      geofenceRadius
      state
      district
      pincode
      address
    }
    pointOfContacts {
      id
      fullName
      number
    }
    deliveryConditions {
      deliveryCosts {
        costRange
        deliveryCost
      }
      estimatedDelta
      minCartValue
      isManufacturingPlant
      extraSapCodes {
        businessPlace
        profitCenter
        costCenter
      }
      gstDetails {
        gstin
        registeredName
        address1
        address2
        stateName
        stateCode
        district
        pincode
      }
    }
    deliverySlots {
      ...TimeSlotFrag
    }
    maintenanceSlots {
      ...TimeSlotFrag
    }
    pickupSlots {
      ...TimeSlotFrag
    }
    surveyareaSet {
      id
      geometry {
        type
        coordinates
      }
      properties {
        isActive
        name
        codename
        primaryUser {
          id
          fullName
          number
        }
        updatedAt
        users {
          id
          fullName
          number
        }
      }
    }
    alternateSalesSlots {
      ...TimeSlotFrag
    }
  }
  ${TIME_SLOT_FRAG}
`

export const STORAGE_LOCATION_FRAG = gql`
  fragment StorageLocationFrag on DCStorageLocationType {
    id
    name
    codename
    archive
    colorCode
    responsiblePerson {
      id
      firstName
      lastName
      fullName
      number
    }
    subLocations {
      id
      name
      codename
    }
  }
`
